import { createReducer } from 'redux-act';

import { ISelectedTags, ITagData } from './tags.types';
import {
  loadAvailableTagsFail,
  loadAvailableTagsRequest,
  loadAvailableTagsSuccess,
  loadSelectedTagsFail,
  loadSelectedTagsRequest,
  loadSelectedTagsSuccess,
  saveSelectedTagsFail,
  saveSelectedTagsRequest,
  saveSelectedTagsSuccess,
} from './tags.actions';

export interface ITagsState {
  isLoading: boolean;
  selectedTags: {
    isLoaded: boolean;
    data: ISelectedTags | null;
  };
  availableTags: ITagData[];
  isSaveInProgress: boolean;
}

export const initialTagsState: ITagsState = {
  isLoading: false,
  selectedTags: {
    isLoaded: false,
    data: {
      tagIds: [],
      displayedTags: [],
    },
  },
  availableTags: [],
  isSaveInProgress: false,
};

const reducer = createReducer({}, initialTagsState);

reducer
  .on(loadSelectedTagsRequest, state => ({
    ...state,
    isLoading: true,
    selectedTags: {
      ...state.selectedTags,
      isLoaded: false,
    },
  }))
  .on(loadSelectedTagsSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    selectedTags: {
      ...state.selectedTags,
      isLoaded: true,
      data: payload,
    },
  }))
  .on(loadSelectedTagsFail, state => ({
    ...state,
    isLoading: false,
    selectedTags: {
      ...state.selectedTags,
      isLoaded: false,
    },
  }))

  .on(loadAvailableTagsRequest, state => ({
    ...state,
    isLoading: true,
  }))
  .on(loadAvailableTagsSuccess, (state, payload) => ({
    ...state,
    isLoading: false,
    availableTags: payload,
  }))
  .on(loadAvailableTagsFail, state => ({
    ...state,
    isLoading: false,
  }))

  .on(saveSelectedTagsRequest, state => ({
    ...state,
    isSaveInProgress: true,
  }))
  .on(saveSelectedTagsSuccess, (state, payload) => ({
    ...state,
    isSaveInProgress: false,
    selectedTags: {
      ...state.selectedTags,
      isLoaded: true,
      data: payload,
    },
  }))
  .on(saveSelectedTagsFail, state => ({
    ...state,
    isSaveInProgress: false,
  }));

export default reducer;
